import { render, staticRenderFns } from "./SubEixo.vue?vue&type=template&id=522da7a9&scoped=true&"
import script from "./SubEixo.vue?vue&type=script&lang=js&"
export * from "./SubEixo.vue?vue&type=script&lang=js&"
import style0 from "./SubEixo.vue?vue&type=style&index=0&id=522da7a9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522da7a9",
  null
  
)

export default component.exports